import { Vec3, _decorator, Node } from 'cc';
import Processor from '../Misc/Processor';

const { ccclass } = _decorator;

enum EventType {}

export type BaseMovingEffectOption = {
    target?: Node;
    fromPos?: Readonly<Vec3>;
    toPos?: Readonly<Vec3>;
    /** time of effect starts from, in milliseconds */
    startAt?: number;
    overrideDuration?: number;
};

@ccclass('BaseMovingEffect')
export default abstract class BaseMovingEffect extends Processor {
    public static readonly EVENT_TYPE = { ...EventType, ...Processor.EVENT_TYPE };

    public play(option?: BaseMovingEffectOption): Promise<void> {
        return super.play(option);
    }
    protected abstract run(option?: BaseMovingEffectOption): ReturnType<Processor['run']>;
}
